import React, {useEffect, useState} from 'react';
import './FormularioPago.css';
import {useElements, useStripe, PaymentElement} from '@stripe/react-stripe-js';

const FormularioPago = (props) => {
	const {
		factura,
		stripeMessage,
		createPayment,
		enviarYMostrarResultado,
		setActiveStep,
		activeStep,
		setHabilitado
	} = props;
	const elements = useElements();
	const stripe = useStripe();
	const [message, setMessage] = useState();
	const [cargando, setCargando] = useState(false);
	const [invoice, setInvoice] = useState();
	const [nombreTarjeta, setNombreTarjeta] = useState()

	useEffect(() => {
		async function saveIdFactura() {
			if (factura) {
				try {
					await enviarYMostrarResultado();
					setActiveStep(activeStep + 1);
				} catch {}
			}
		}
		saveIdFactura();
	}, [invoice]);

	const manejarCambios = (ev) => {
		if (ev.complete) {
			document.getElementById('button-form').style.pointerEvents = 'initial';
		} else {
			document.getElementById('button-form').style.pointerEvents = 'none';
		}
	};

	const enviarElements = async (ev) => {
		if (!stripe || !elements) return;

		setCargando(true);
		
		document.getElementById('button-form').style.pointerEvents = 'none';

		elements.submit();
		const {error, paymentMethod} = await stripe.createPaymentMethod({
			elements,
			confirmParams: {
			payment_method_data: {
				billing_details: {
				name: nombreTarjeta,
				},
			},
			},
			redirect: 'if_required',
		});		

		if (error) {
			setCargando(false);
			if (error === 'expired_card') {
				setMessage('Su tarjeta ha expirado');
			} else {
				if (error === 'processing_error') {
					setMessage('Error de procesamiento');
				} else {
					setMessage('Tarjeta rechazada');
				}
			}
		}else {
			let aceptado = await createPayment(paymentMethod?.id);

			if (aceptado) {
				setInvoice(factura);
			}
		}
		setHabilitado(true)
	};

	return (
		<form className='payment-form'>
			<div className='div-form d-flex flex-column gap-1'>
				<label><b>Nombre del titular de la tarjeta</b></label>
				<input
				type='text'
				value={nombreTarjeta}
				onChange={(e) => setNombreTarjeta(e.target.value)}
				placeholder='Nombre de la tarjeta'
				required
				className='form-control text-dark'
				/>
				<label className='mt-3'>
					<b>Información de la tarjeta</b>
				</label>
				<hr />
				<PaymentElement onChange={manejarCambios} />
				<div id='mensaje-stripe'>{message}</div>
				<div className='w-full text-center'>
					<div
						id='button-form'
						className='btn button-stripe mt-4'
						onClick={enviarElements}
					>
						{cargando ? 'Cargando...' : 'Pagar'}
					</div>
				</div>
			</div>
		</form>
	);
};

export default FormularioPago;
